 <template>
	<div>
		<div v-if="remark" class="approve">
			<c-input v-model="remarkValue" class="approve-remark" placeholder="审批意见"></c-input>
		</div>
		<c-dialog ref="dialog" title="事务流转" width="450" @resolve="submit">
			<c-form ref="form">
				<c-form-item v-show="approverList.length" label="审批人" required>
					<c-select name="employeeId" :options="approverList"></c-select>
				</c-form-item>
				<c-form-item label="选择抄送人">
					<c-select name="copyEmpId" multiple async @search="updateStaff"></c-select>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			remark: Boolean
		},
		
		data() {
			return {
				state: -1,
				approverList: [],
				copyToList: [],
				remarkValue: '',
                _config: null,
                _callback: null
			}
		},
		
		methods: {
			launch(data, callback, state) {
				// 保存 state：-1=暂存、0=驳回、1=提交
				this.state = state !== undefined ? state : -1;

				if (!this.state && this.remark && !this.remarkValue.trim()) {
					this.$message({
						message: '请输入审批意见'
					});
					return;
				}

				// 暂存（state == -1）：与移动端一致，直接 callback，不调流程接口
				if (this.state == -1) {
					callback && callback();
					return;
				}

				this._config = data;
				this._callback = callback;
				this.$refs.form.clear();
				this.approverList = Array.from(data.approver || [], item => {
					return {
						name: item.name,
						value: item.id
					}
				});
				this.copyToList =  Array.from(data.copeToEmps || [], item => {
					return {
						name: item.name,
						value: item.id
					}
				});

				// 提交时如果未配置审批人，提示用户并拦截（避免后端产生无法撤销的"假审批中"状态）
				if (!this.approverList.length) {
					this.$message({message: '未配置下一级审批人，请联系管理员配置审批流程', type: 'warning'});
					return;
				}

				// 提交时总是弹 dialog 让用户确认审批人（与移动端 doc_flow.apply 行为一致），
				// 避免"审批人唯一时自动选中"导致后端记录错误的审批人
				if (this.approverList.length == 1) {
					this.$refs.form.set({
						employeeId: this.approverList[0].value
					});
				}
				this.$refs.dialog.open();
			},
			
			approve(state, data, callback) {
				if (!state){
					data = {
						formId: data.formId
					};
				}
				this.state = state ? 1 : 0;
				this.launch(data, callback);
			},
			
			updateStaff(keyword, resolve) {
				this.request({
					url: '/sys_user/mini/select_list',
					data: {
						view_model: 2,
						keyword: keyword.trim()
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.user_realname,
								value: item.id
							}
						}))
					}
				});
			},
			
			submit(stop, next) {
				stop && stop();
				this.$refs.form.submit({
					// 与移动端 doc_flow.apply 一致：提交时调用 update_approver 设置新事务的审批人/撚送人
					// （/flow/transaction/approve 是 doc_handle 审批/驳回的接口，executeState 为 1/9）
					url: '/flow/transaction/update_approver',
					rule: {
						employeeId: [{
							type: 'empty',
							message: '请选择审批人',
							skip: () => {
								return !this.approverList.length;
							}
						}]
					},
					dataFormatter: data => {
						data.formId = this._config.formId;
						data.copyEmpId = data.copyEmpId ? data.copyEmpId.join(',') : '';
						data.remark = this.remarkValue.trim();
						return data;
					},
					success: () => {
						this.state = -1;
						next && next();
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this._callback && this._callback();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.approve {
		border-top: 1px solid #eee;
		padding: 12px;
		
		&-remark {
			>>> textarea {
				height: 60px;
				min-height: auto;
			}
		}
	}
</style>